<p-toast [style]="{float: 'left'}" position="center" key="r" [baseZIndex]="1000">
  <ng-template let-content pTemplate="content">
    <div style="text-align: left">
      <h3>{{content.summary}}</h3>
      <div innerHtml="{{content.detail}}">
        <mat-divider>
        </mat-divider>
      </div>
      <button style="float: right" type="button" pButton label="Ok" (click)="messageService.clear();"
      class="ui-button"></button>
    </div>
  </ng-template>
</p-toast>


<div class="container-fluid rate-season-summary-table rate-summary-report">
    <div class="row justify-content-between">
      <div class="custom-col-left">
        <app-search-template searchLabel="Search" [showSearchButton]=true [reset]=true [showLocations]=true
          [showDevelopments]=false [showShortTermRentals]=false [showRateBuckets]=false [showBedrooms]=true
          [showSeasons]=false [showStartDate]=true [showYieldMaxProperties]=true [showYieldMaxDevelopments]=true
          [showYieldMaxRateBuckets]=true [showCustomDateRange]="true" [dateRange]="'yearFromToday'" [showEndDate]=true
        [shortTermRentalId] = "propertyId" [propertyCode] = "propertyCode" (doSearchCB)="onSearchSubmit($event)"></app-search-template>
      </div>
      <div class="custom-col-right d-flex text-start justify-content-end align-items-center gap-3">
        <span class="d-flex align-items-center gap-1">
          <p-radioButton name="sortField" value="occPct" [(ngModel)]="selectedSortField" (ngModelChange)="onSortFieldChange($event)"></p-radioButton>
          <label style="white-space:nowrap; margin:0; cursor:pointer;">Occ Pct</label>
        </span>
        <span class="d-flex align-items-center gap-1">
          <p-radioButton name="sortField" value="achivedRoomRateRevPct" [(ngModel)]="selectedSortField" (ngModelChange)="onSortFieldChange($event)"></p-radioButton>
          <label style="white-space:nowrap; margin:0; cursor:pointer;">Rev Pct</label>
        </span>
      </div>

      <!-- <div class="genrateRates custom-col-right d-flex text-end justify-content-end align-items-center">
      <p-button label="Generate Rates for All Properties" severity="secondary" class="my-2 d-block btn-secondary btn-warning-custom"
      (click)="generateRates()"></p-button>
    </div> -->
  </div>
    @if (advertisedRateRows?.length > 0) {
      <div style="font-size:12px;color:#555;padding:2px 0 3px 0;">
        Showing <strong>{{ advertisedRateRows.length }}</strong> {{ advertisedRateRows.length === 1 ? 'property' : 'properties' }}
      </div>
    }
    <p-table [contextMenu]="menu" class="rate-seasons-summary-table" #dt [value]="advertisedRateRows" [columns]="scrollingColumns" scrollDirection="both" [frozenWidth]="frozenWidth"
      [scrollable]="true" scrollHeight="flex" sortMode="multiple" [loading]="formLoading"
      style="width: auto; flex: 1; min-height: 0;">
      <ng-template pTemplate="header" let-columns>
        <tr>
          @for (col of frozenColumns; track col.field) {
            <th style="width:75px;height:48px;padding: .2em .2em !important;position:sticky;z-index:2;"
              [style.left]="col.left"
              [pSortableColumn]="col.field">
              <div class="d-flex flex-column" style="gap:2px;">
                <!-- Header label + sort icon on one line -->
                <div class="d-flex align-items-center gap-1" style="white-space:nowrap;">
                  <span style="font-size:11px;">{{col.header}}</span>
                  @if (dt.sortField === col.field) {
                    <i [ngClass]="{'pi pi-sort-up': dt.sortOrder === 1, 'pi pi-sort-down': dt.sortOrder === -1}" style="font-size:9px;"></i>
                  }
                  @if (dt.sortField !== col.field) {
                    <i class="pi pi-sort" style="font-size:9px;"></i>
                  }
                </div>
                <!-- Filter input on second line -->
                @if (col.field === 'propertyCode') {
                  <input (click)="clickOnFilter($event)" style="width:50px;height:18px;font-size:10px;padding:1px 3px;"
                    pInputText type="text" (input)="dt.filter($event.target.value, col.field, 'contains')">
                }
                @if (col.field === 'rateBucketName') {
                  <input (click)="clickOnFilter($event)" style="width:50px;height:18px;font-size:10px;padding:1px 3px;"
                    pInputText type="text" (input)="dt.filter($event.target.value, col.field, 'contains')">
                }
                @if (col.field === 'bedrooms') {
                  <input (click)="clickOnFilter($event)" style="width:40px;height:18px;font-size:10px;padding:1px 3px;"
                    pInputText type="text" (input)="dt.filter($event.target.value, col.field, 'startsWith')">
                }
                @if (col.field === 'annualRevTargetAmnt') {
                  <input (click)="clickOnFilter($event)" style="width:40px;height:18px;font-size:10px;padding:1px 3px;"
                    pInputText type="text" (input)="dt.filter($event.target.value, col.field, 'startsWith')">
                }
                @if (col.field === 'rateBucketAdjusterPct') {
                  <input (click)="clickOnFilter($event)" style="width:50px;height:18px;font-size:10px;padding:1px 3px;"
                    pInputText type="text" (input)="dt.filter($event.target.value, col.field, 'contains')">
                }
              </div>
            </th>
      }
      @for (col of columns; track col.field) {
        <th style="width:228px;height:48px;padding: .2em .2em !important;"
          (click)="toggleSort(col.startDate)">
          <span>
            {{ col.header }}
            @if (sortingState[col.startDate] === 'asc') {
              <i class="pi pi-sort-amount-up"></i>
            }
            @if (sortingState[col.startDate] === 'desc') {
              <i class="pi pi-sort-amount-down"></i>
            }
          </span>
          <div>@if (col.field === 'propertyCode') {
            <input (click)="clickOnFilter($event)" style="width:50px"
              pInputText type="text" (input)="dt.filter($event.target.value, col.field, 'contains')">
          }
        </div>
        <div>@if (col.field === 'rateBucketName') {
          <input (click)="clickOnFilter($event)" style="width:50px"
            pInputText type="text" (input)="dt.filter($event.target.value, col.field, 'contains')">
        }
      </div>
      <div>@if (col.field === 'bedrooms') {
        <input (click)="clickOnFilter($event)" style="width:40px" pInputText
          type="text" (input)="dt.filter($event.target.value, col.field, 'startsWith')">
      }</div>
      <div>@if (col.field === 'annualRevTargetAmnt') {
        <input (click)="clickOnFilter($event)" style="width:40px" pInputText
          type="text" (input)="dt.filter($event.target.value, col.field, 'startsWith')">
      }</div>
      <!-- <div><input (click)="clickOnFilter($event)" style="width:100px" *ngIf="col.field === 'adrDevelopmentName'" pInputText type="text" (input)="dt.filter($event.target.value, col.field, 'contains')"></div> -->
      <div>@if (col.field === 'rateBucketAdjusterPct') {
        <input (click)="clickOnFilter($event)" style="width:50px"
          pInputText type="text"
          (input)="dt.filter($event.target.value, col.field, 'contains')">
      }</div>
    </th>
  }
</tr>
</ng-template>
<ng-template pTemplate="body" let-rowData let-columns="columns">
  <tr>
    @for (col of frozenColumns; track col.field) {
      <td style="width:75px;height:148px;overflow:hidden; padding: .2em .2em !important;position:sticky;z-index:1;"
        [style.left]="col.left"
        [style.border-right]="getSeasonColor(rowData[col.field],col.field)"
        [style.background-color]="getOccupiedBackgroundColor(rowData[col.field],col.field) || 'white'">
        @if (col.field === 'rateBucketName') {
          <span>
            {{rowData[col.field]}}
          </span>
        }
        @if (col.field === 'bedrooms') {
          <span>
            {{rowData[col.field]}}
          </span>
        }
        @if (col.field === 'annualRevTargetAmnt') {
          <span>
            {{rowData[col.field]}}
          </span>
        }
        <!-- <span *ngIf="col.field === 'adrDevelopmentName'">
        {{calcYearlyGrossRev(rowData).yrListPrice | currency : 'USD' : 'symbol' : '1.0-0'}}<br>
        <b>{{calcYearlyGrossRev(rowData).yrPropertyListPrice | currency : 'USD' : 'symbol' :
        '1.0-0'}}</b><br>
        {{calcYearlyGrossRev(rowData).yrYMDiscFloorPrice | currency : 'USD' : 'symbol' :
        '1.0-0'}}<br>
        <span>&nbsp;</span><br>
        {{calcYearlyGrossRev(rowData).yrListPriceAdj | currency : 'USD' : 'symbol' : '1.0-0'}}
      </span> -->
      @if (col.field === 'propertyCode') {
        <span>
          <a style=" text-decoration: none; color: blue;" (click)="onRowSelect(rowData[0])"
          target="_blank">{{rowData[col.field]}}</a>
        </span>
      }
      @if (col.field === 'rateBucketAdjusterPct') {
        <span>
          <input #rateBucketAdjusterPct
            (change)="onRateBucketAdjusterPctChange(rowData[0].propertyId,rateBucketAdjusterPct.value,rowData);rateBucketAdjusterPct.style.backgroundColor = '#FFCCCB';cl3.style.visibility = 'visible';"
            pInputText type="text" value="{{formatPercent(rowData.rateBucketAdjusterPct)}}"
            style="width:65px;margin-bottom:3px;">
							<a #cl3 href="javascript:" (click)="onRateBucketAdjusterPctSave(rowData[0].propertyId,rateBucketAdjusterPct.value);rateBucketAdjusterPct.style.backgroundColor = 'transparent';
							cl3.style.visibility = 'hidden';" style="margin-left:2px;visibility:hidden;color:red"><i
            class="pi pi-save"></i></a>
            <br>&nbsp;
              <a #cl1 href="javascript:"
                (click)="decRateBucketAdjPct(rowData[0].propertyId,rateBucketAdjusterPct.value,rowData);rateBucketAdjusterPct.style.backgroundColor = '#FFCCCB';cl3.style.visibility = 'visible';"><i
              class="pi pi-minus"></i></a>&nbsp;&nbsp;&nbsp;
              <a #cl2 href="javascript:"
                (click)="incRateBucketAdjPct(rowData[0].propertyId,rateBucketAdjusterPct.value,rowData);rateBucketAdjusterPct.style.backgroundColor = '#FFCCCB';cl3.style.visibility = 'visible';"><i
              class="pi pi-plus"></i></a>
            </span>
          }
          @if (col.field!='rateBucketName'&&col.field!='bedrooms'&&col.field!='annualRevTargetAmnt'&&col.field!='rateBucketAdjusterPct'&&col.field!='propertyCode'&&rowData[col.field]) {
            <span
              >
              <input #listPrice
                (change)="onListPriceChange(rowData[col.field].rateBucketDetailId,listPrice.value);cl6.style.visibility = 'visible';listPrice.style.backgroundColor = '#FFCCCB';"
                type="text" value="{{calcListPrice(rowData[col.field])}}"
                style="width:65px;margin-bottom:3px;">&nbsp;
                <a #cl4 href="javascript:"
                  (click)="decListPrice(rowData[col.field].rateBucketDetailId,listPrice.value);listPrice.style.backgroundColor = '#FFCCCB';cl6.style.visibility = 'visible';"><i
                class="pi pi-minus"></i></a>&nbsp;
                <a #cl5 href="javascript:"
                  (click)="incListPrice(rowData[col.field].rateBucketDetailId,listPrice.value);listPrice.style.backgroundColor = '#FFCCCB';cl6.style.visibility = 'visible';"><i
                class="pi pi-plus"></i></a>&nbsp;
                <a #cl6 href="javascript:"
                  (click)="onRateBucketListPriceSave(rowData[col.field].rateBucketDetailId,listPrice.value);listPrice.style.backgroundColor = 'transparent';cl6.style.visibility = 'hidden';"
                  style="margin-left:2px;visibility:hidden;color:red"><i class="pi pi-save"></i></a>
                  &nbsp;&nbsp;&nbsp;
                  @if (rowData[col.field].seasonLastUpdateDays != null) {
                    <span>
                      {{rowData[col.field].seasonLastUpdateDays}}d
                    </span>
                  }
                  <br>
                    <span>
                      <b>{{calcPropertyListPrice(rowData[col.field]) | currency : 'USD' : 'symbol' :
                      '1.0-0'}}</b>
                    </span>
                    @if (rowData[col.field].rateBucketAdjusterPct) {
                      <span>
                        {{(+rowData[col.field].rateBucketAdjusterPct || 0) | percent}}
                      </span>
                    }
                    <br>
                      <!-- <span (click)="onOpenRateBucketDetailEdit(rowData[col.field].rateBucketDetailId, $event)"> -->
                      <span>
                        <span>
                          {{calcYMDiscFloorPrice(rowData[col.field]) | currency : 'USD' : 'symbol' : '1.0-0'}}
                        </span>
                        @if (rowData[col.field].discountMaxPercent||rowData[col.field].discountLookForwardDays) {
                          <span
                            >
                            -{{(+rowData[col.field].discountMaxPercent || 0) |
                            percent}}&nbsp;{{rowData[col.field].discountLookForwardDays}}d
                          </span>
                        }
                      </span>
                      <br>
                        <!-- <span (click)="onOpenRateBucketDetailEdit(rowData[col.field].rateBucketDetailId, $event)"> -->
                        <span>
                          @if (rowData[col.field].minimumPriceSetByManager) {
                            <span>
                              {{rowData[col.field].minimumPriceSetByManager | currency : 'USD' : 'symbol' :
                              '1.0-0'}}
                            </span>
                          }
                          @if (rowData[col.field].minStayExpected) {
                            <span>
                              {{rowData[col.field].minStayExpected}}d
                              <span style="padding:2px;"
                                [style.background-color]="calcMinListPrice(rowData[col.field]).color">{{calcMinListPrice(rowData[col.field]).rate
                              | currency : 'USD' : 'symbol' : '1.0-0'}}</span>
                            </span>
                            }&nbsp;
                            @if (rowData[col.field].seasonOccupancy) {
                              <span>
                                {{(+rowData[col.field].seasonOccupancy || 0) | percent}}
                              </span>
                            }
                          </span>
                          <br>
                            <!-- <span>
                            {{calcListPriceAdjPct(rowData[col.field]) | currency : 'USD' : 'symbol' : '1.0-0'}}
                          </span> -->
                          <span>
                            {{(+rowData[col.field].listPriceAdjustmentPercent || 0) | percent}}
                            {{(+rowData[col.field].listPriceAdjustmentAmount || 0) | percent}}
                          </span>
                          <!-- <span class="rate-bucket-edit" (click)="onOpenRateBucketDetailEdit(rowData[col.field].rateBucketDetailId, $event)"> -->
                          <span class="rate-bucket-edit">
                            @if (rowData[col.field].nightlyRateTTL != null) {
                              <span title="Total Room Rate">
                                {{rowData[col.field].nightlyRateTTL | currency : 'USD' : 'symbol' : '1.0-0'}}
                              </span>
                              }&nbsp;
                              @if (rowData[col.field].daysInSeasonTTL && rowData[col.field].seasonOccupancy) {
                                <span>
                                  @if (rowData[col.field].nightlyRateTTL != null) {
                                    <span style="width:40px; display: inline-block;" title="Achived Targeted Room Rate Pct">
                                      {{calcSeasonAchivedRevanuePct(rowData[col.field]) | currency : 'USD' : 'symbol' :
                                      '1.0-2'}}
                                    </span>
                                    }&nbsp;
                                    @if (rowData[col.field].nightlyRateTTL != null) {
                                      <span title="Expected Total Room Rate by Occupancy">
                                        {{calcSeasonExpectedRevanue(rowData[col.field]) | currency : 'USD' : 'symbol' :
                                        '1.0-0'}}
                                      </span>
                                    }
                                  </span>
                                }
                              </span>
                              <br>
                                <!-- <span (click)="onOpenRateBucketDetailEdit(rowData[col.field].rateBucketDetailId, $event)"> -->
                                <span>
                                  <span>
                                    @if (rowData[col.field].totalGuestResNts != null) {
                                      <span title="Total Guest nights">
                                        {{rowData[col.field].totalGuestResNts}}
                                      </span>
                                    }
                                    @if (rowData[col.field].totalOtherResNts != null) {
                                      <span title="Total Other nights">
                                        {{rowData[col.field].totalOtherResNts}}
                                      </span>
                                    }
                                    @if (rowData[col.field].daysInSeasonTTL != null) {
                                      <span title="Total days in a season">
                                        {{rowData[col.field].daysInSeasonTTL}}
                                      </span>
                                    }
                                  </span>&nbsp;
                                  @if (rowData[col.field].occPct != null) {
                                    <span title="Occupancy">
                                      {{(+rowData[col.field].occPct || 0) | percent}}
                                    </span>
                                    }&nbsp;
                                    @if (rowData[col.field].totalVacantNts != null) {
                                      <span title="Remaining future bookable nights in this season as of today">
                                        {{rowData[col.field].totalVacantNts}}
                                      </span>
                                    }
                                  </span>
                                </span>
                              }
                            </td>
                          }
                          @for (col of columns; track col.field) {
                            <td [ngClass]="rowData[col.field]?.occPct >= rowData[col.field]?.seasonOccupancy ? 'main-bx bg-green' : rowData[col.field]?.occPct >= (rowData[col.field]?.seasonOccupancy - 0.3) ? 'main-bx bg-yellow' : 'main-bx bg-pink'"
                              [style.border-right]="getSeasonColor(rowData[col.field],col.field)"
                              [style.background-color]="getOccupiedBackgroundColor(rowData[col.field],col.field)"
                              [style.overflow]="'hidden'"
                              [style.align-items]="'flex-start'"
                              [style.cursor]="'pointer'"
                              (click)="rowData[col.field] && openCm($event, menu, rowData[col.field])">
                              @if (col.field === 'rateBucketName') {
                                <span>
                                  {{rowData[col.field]}}
                                </span>
                              }
                              @if (col.field === 'bedrooms') {
                                <span>
                                  {{rowData[col.field]}}
                                </span>
                              }
                              @if (col.field === 'annualRevTargetAmnt') {
                                <span>
                                  {{rowData[col.field]}}
                                </span>
                              }
                              <!-- <span *ngIf="col.field === 'adrDevelopmentName'">
                              {{calcYearlyGrossRev(rowData).yrListPrice | currency : 'USD' : 'symbol' : '1.0-0'}}<br>
                              <b>{{calcYearlyGrossRev(rowData).yrPropertyListPrice | currency : 'USD' : 'symbol' :
                              '1.0-0'}}</b><br>
                              {{calcYearlyGrossRev(rowData).yrYMDiscFloorPrice | currency : 'USD' : 'symbol' :
                              '1.0-0'}}<br>
                              <span>&nbsp;</span><br>
                              {{calcYearlyGrossRev(rowData).yrListPriceAdj | currency : 'USD' : 'symbol' : '1.0-0'}}
                            </span> -->
                            @if (col.field === 'propertyCode') {
                              <span>
                                <a style=" text-decoration: none; color: blue;" (click)="onRowSelect(rowData[0])"
                                target="_blank">{{rowData[col.field]}}</a>
                              </span>
                            }
                            @if (col.field === 'rateBucketAdjusterPct') {
                              <span>
                                <input #rateBucketAdjusterPct
                                  (change)="onRateBucketAdjusterPctChange(rowData[0].propertyId,rateBucketAdjusterPct.value,rowData);rateBucketAdjusterPct.style.backgroundColor = '#FFCCCB';cl3.style.visibility = 'visible';"
                                  pInputText type="text" value="{{formatPercent(rowData.rateBucketAdjusterPct)}}"
                                  style="width:65px;margin-bottom:3px;">
							<a #cl3 href="javascript:" (click)="$event.stopPropagation();onRateBucketAdjusterPctSave(rowData[0].propertyId,rateBucketAdjusterPct.value);rateBucketAdjusterPct.style.backgroundColor = 'transparent';
							cl3.style.visibility = 'hidden';" style="margin-left:2px;visibility:hidden;color:red"><i
                                  class="pi pi-save"></i></a>
                                  <br>&nbsp;
                                    <a #cl1 href="javascript:"
                                      (click)="$event.stopPropagation();decRateBucketAdjPct(rowData[0].propertyId,rateBucketAdjusterPct.value,rowData);rateBucketAdjusterPct.style.backgroundColor = '#FFCCCB';cl3.style.visibility = 'visible';"><i
                                    class="pi pi-minus"></i></a>&nbsp;&nbsp;&nbsp;
                                    <a #cl2 href="javascript:"
                                      (click)="$event.stopPropagation();incRateBucketAdjPct(rowData[0].propertyId,rateBucketAdjusterPct.value,rowData);rateBucketAdjusterPct.style.backgroundColor = '#FFCCCB';cl3.style.visibility = 'visible';"><i
                                    class="pi pi-plus"></i></a>
                                  </span>
                                }
                                @if (col.field!='rateBucketName'&&col.field!='bedrooms'&&col.field!='annualRevTargetAmnt'&&col.field!='rateBucketAdjusterPct'&&col.field!='propertyCode'&&rowData[col.field]) {
                                  <span>
                                    <!-- ── GRID TOP: rows 1–4 ──────────────────────────────────────────────────────────────────────────────────────────
                                         Cols: [62px input/price] [50px adj/info] [50px ctrl/days] [auto badge/extra]
                                    ────────────────────────────────────────────────────────────────────────────────────────── -->
                                    <div class="ssb-grid-top">
                                      <!-- Row 1 col A: price adjustment input -->
                                      <span style="overflow:visible; align-self:center;">
                                        <input #listPriceAdjustmentAmount
                                          (click)="$event.stopPropagation()"
                                          (change)="onListPriceChange(rowData[col.field].rateBucketDetailId,listPriceAdjustmentAmount.value);cl6.style.visibility = 'visible';listPriceAdjustmentAmount.style.backgroundColor = '#FFCCCB';"
                                          type="text" value="{{calcListPriceAdj(rowData[col.field])}}"
                                          style="width:58px;">
                                      </span>
                                      <!-- Row 1 col B: list price -->
                                      <span style="overflow:hidden; white-space:nowrap; font-size:0.8rem; align-self:center;" (click)="$event.stopPropagation()">{{calcListPrice(rowData[col.field]) | currency : 'USD' : 'symbol' :'1.0-0'}}</span>
                                      <!-- Row 1 col C: −/+/save controls -->
                                      <span style="overflow:visible; display:flex; gap:3px; align-items:center; align-self:center; position:relative; z-index:10;">
                                        <a #cl4 href="javascript:"
                                          (click)="$event.stopPropagation();decListPrice(rowData[col.field].rateBucketDetailId,listPriceAdjustmentAmount.value);listPriceAdjustmentAmount.style.backgroundColor = '#FFCCCB';cl6.style.visibility = 'visible';"><i class="pi pi-minus"></i></a>
                                        <a #cl5 href="javascript:"
                                          (click)="$event.stopPropagation();incListPrice(rowData[col.field].rateBucketDetailId,listPriceAdjustmentAmount.value);listPriceAdjustmentAmount.style.backgroundColor = '#FFCCCB';cl6.style.visibility = 'visible';"><i class="pi pi-plus"></i></a>
                                        <a #cl6 href="javascript:" style="visibility:hidden; color:red; position:relative; z-index:10;"
                                          (click)="$event.stopPropagation();onRateBucketListPriceSave(rowData[col.field].rateBucketDetailId,listPriceAdjustmentAmount.value);listPriceAdjustmentAmount.style.backgroundColor = 'transparent';cl6.style.visibility = 'hidden';"><i class="pi pi-save"></i></a>
                                      </span>
                                      <!-- Row 1 col D: day badges (last booking + season update) -->
                                      <span style="overflow:hidden; display:flex; gap:3px; align-items:center; font-size:0.8rem;" (click)="$event.stopPropagation()">
                                        @if (rowData[col.field].lastBookingSaleDays != null) {
                                          <span class="text-blue" title="Number of nights since the last booking sale date with a reservation">{{rowData[col.field].lastBookingSaleDays}}d</span>
                                        }
                                        @if (rowData[col.field].seasonLastUpdateDays != null) {
                                          <span [ngClass]="rowData[col.field].seasonLastUpdateDays > 10 ? 'season-last-update bg-red'
                                            : rowData[col.field].seasonLastUpdateDays > 5 ? 'season-last-update bg-bright-yellow' : ''"
                                            title="Season last updated">{{rowData[col.field].seasonLastUpdateDays}}d</span>
                                        }
                                      </span>

                                      <!-- Row 2 col A: yield price -->
                                      <span class="text-bold" title="Yield price after bucket adjustments">{{calcPropertyListPrice(rowData[col.field]) | currency : 'USD' : 'symbol' : '1.0-0'}}</span>
                                      <!-- Row 2 col B: rate bucket adj% -->
                                      @if (rowData[col.field].rateBucketAdjusterPct) {
                                        <span class="text-red" title="Rate Bucket Adjustment Pct">{{(+rowData[col.field].rateBucketAdjusterPct || 0) | percent}}</span>
                                      } @else { <span></span> }
                                      <!-- Row 2 col C: list price adj% -->
                                      @if (rowData[col.field].listPriceAdjustmentPercent != null) {
                                        <span title="List Price Adjustment Pct">{{(+rowData[col.field].listPriceAdjustmentPercent || 0) | percent}}</span>
                                      } @else { <span></span> }
                                      <!-- Row 2 col D: (empty) -->
                                      <span></span>

                                      <!-- Row 3 col A: YM disc floor price -->
                                      <span title="YM Disc Floor Price">{{calcYMDiscFloorPrice(rowData[col.field]) | currency : 'USD' : 'symbol' : '1.0-0'}}</span>
                                      <!-- Row 3 cols B/C/D: max discount % | look-fwd days | start date -->
                                      @if (rowData[col.field].discountMaxPercent || rowData[col.field].discountLookForwardDays) {
                                        <span title="Max discount pct">-{{(+rowData[col.field].discountMaxPercent || 0) | percent}}</span>
                                        <span title="Looks forward days">{{rowData[col.field].discountLookForwardDays}}d</span>
                                        @if (rowData[col.field].startDiscountingFrom) {
                                          <span title="Start discounting from" style="color:#888;">({{rowData[col.field].startDiscountingFrom | date:'MMM d'}})</span>
                                        } @else { <span></span> }
                                      } @else {
                                        <span></span><span></span><span></span>
                                      }

                                      <!-- Row 4 col A: min stay expected days -->
                                      @if (rowData[col.field].minStayExpected) {
                                        <span title="Min nts expected" style="white-space:nowrap;">{{rowData[col.field].minStayExpected}}d</span>
                                      } @else { <span></span> }
                                      <!-- Row 4 col B: calc min list price badge — justify-self:start keeps bg tight to text -->
                                      @if (rowData[col.field].minStayExpected) {
                                        <span [title]="'Manager floor: ' + (rowData[col.field].minimumPriceSetByManager || 'Not Set') + ', Owner floor: ' + (rowData[col.field].minimumPriceSetByOwner || 'Not Set') + ', Global floor: ' + (rowData[col.field].minNightlyRate || 'Not Set')"
                                              style="padding:2px; white-space:nowrap; justify-self:start;"
                                              [style.background-color]="calcMinListPrice(rowData[col.field]).color">{{calcMinListPrice(rowData[col.field]).rate | currency : 'USD' : 'symbol' : '1.0-0'}}</span>
                                      } @else { <span></span> }
                                      <!-- Row 4 col C: expected occupancy% -->
                                      @if (rowData[col.field].seasonOccupancy) {
                                        <span title="Expected Season Occupancy">{{(+rowData[col.field].seasonOccupancy || 0) | percent}}</span>
                                      } @else { <span></span> }
                                      <!-- Row 4 col D: min nts required -->
                                      @if (rowData[col.field].minLengthOfStay != null) {
                                        <span title="Min nts required" style="white-space:nowrap;">{{rowData[col.field].minLengthOfStay}}d&nbsp;min</span>
                                      } @else { <span></span> }
                                    </div>

                                    <!-- ── GRID MID: rows 5–6 ──────────────────────────────────────────────────────
                                         Cols: [62px total$] [62px avg$] [40px ach%] [auto exp$]
                                    ────────────────────────────────────────────────────────────────── -->
                                    <div class="ssb-grid-mid">
                                      <!-- Row 5: total rev | avg nightly | achieved% (guest) | expected$ (guest) -->
                                      @if (rowData[col.field].nightlyRateTTL != null) {
                                        <span title="Total Room Rate">{{rowData[col.field].nightlyRateTTL | currency : 'USD' : 'symbol' : '1.0-0'}}</span>
                                      } @else { <span>$0</span> }
                                      @if (rowData[col.field].nightlyRateAvg != null) {
                                        <span title="Nightly Room Rate">({{rowData[col.field].nightlyRateAvg | currency : 'USD' : 'symbol' : '1.0-0'}})</span>
                                      } @else { <span></span> }
                                      @if (rowData[col.field].daysInSeasonTTL && rowData[col.field].seasonOccupancy) {
                                        @if (rowData[col.field].achivedRoomRateRevPctByGuest != null) {
                                          <span title="Achieved Rev Pct (Guest only)">{{(+rowData[col.field].achivedRoomRateRevPctByGuest || 0) | percent}}</span>
                                        } @else { <span>0%</span> }
                                        @if (rowData[col.field].expctRoomRateRevByGuest != null) {
                                          <span title="Expected Total Room Rate by Occupancy (Guest only)">{{rowData[col.field].expctRoomRateRevByGuest | currency : 'USD' : 'symbol' : '1.0-0'}}</span>
                                        } @else { <span>$0</span> }
                                      } @else {
                                        <span></span><span></span>
                                      }
                                      <!-- Row 6: (empty) | (empty) | achieved% (all) | expected$ (all) -->
                                      <span></span>
                                      <span></span>
                                      @if (rowData[col.field].achivedRoomRateRevPct != null) {
                                        <span title="Achieved Targeted Room Rate Pct">{{(+rowData[col.field].achivedRoomRateRevPct || 0) | percent}}</span>
                                      } @else { <span>0%</span> }
                                      @if (rowData[col.field].nightlyRateTTL != null) {
                                        <span title="Expected Total Room Rate by Occupancy">{{calcSeasonExpectedRevanue(rowData[col.field]) | currency : 'USD' : 'symbol' : '1.0-0'}}</span>
                                      } @else { <span>$0</span> }
                                    </div>

                                    <!-- ── GRID BOT: row 7 ────────────────────────────────────────────────────────────────────
                                         Cols: [66px nights] [36px occ%] [58px pending$] [auto vacant]
                                    ────────────────────────────────────────────────────────────────── -->
                                    <div class="ssb-grid-bot">
                                      <!-- Col A: night breakdown badges -->
                                      <span style="display:flex; gap:3px; align-items:center; overflow:visible;">
                                        @if (rowData[col.field].totalGuestResNts != null) {
                                          <span class="bg-grey" title="Total Guest nights">{{rowData[col.field].totalGuestResNts}}d</span>
                                        }
                                        @if (rowData[col.field].totalOtherResNts != null) {
                                          <span class="bg-pink" title="Total Other nights">{{rowData[col.field].totalOtherResNts}}d</span>
                                        }
                                        @if (rowData[col.field].daysInSeasonTTL != null) {
                                          <span title="Total days in season">{{rowData[col.field].daysInSeasonTTL}}d</span>
                                        }
                                      </span>
                                      <!-- Col B: actual occupancy% -->
                                      @if (rowData[col.field].occPct != null) {
                                        <span title="Occupancy">{{(+rowData[col.field].occPct || 0) | percent}}</span>
                                      } @else { <span>0%</span> }
                                      <!-- Col C: pending rate target $ -->
                                      @if (rowData[col.field].totalVacantNts != null) {
                                        <span class="text-blue" title="Pending Room Rate Target">{{(calcPropertyListPrice(rowData[col.field]) * rowData[col.field].totalVacantNts) | currency : 'USD' : 'symbol' : '1.0-0'}}</span>
                                      } @else { <span></span> }
                                      <!-- Col D: vacant nights badge -->
                                      @if (rowData[col.field].totalVacantNts != null) {
                                        <span [ngClass]="rowData[col.field].minStayExpectedNtsAvailable ? 'bg-green' : rowData[col.field].totalVacantNts <= 0 ? '' : 'bg-blue'" title="Available nights in season">{{rowData[col.field].totalVacantNts}}d</span>
                                      } @else { <span></span> }
                                    </div>
                                                  </span>
                                                }
                                              </td>
                                            }
                                          </tr>
                                        </ng-template>
                                      </p-table>
                                      <p-menu appendTo="body" #menu [model]="items" [popup]="true" > </p-menu>
                                    </div>

                                    <p-dialog header="Note" [modal]="true" [(visible)]="showNoteWindow"
                                      [style]="{ width: '50rem', height:'23rem' }" [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
                                      [maximizable]="true">
                                      @if (currentRateBucketDetailId) {
                                        <app-note-list [noteSource]="80" [noteSourceId]="currentRateBucketDetailId"></app-note-list>
                                      }
                                    </p-dialog>

